module.exports = __webpack_public_path__ + "img/card-bg-demo.720ceb82.jpg";